<template>
  <v-card class="child-card-component">
    <section
      :style="{ backgroundColor: background }"
      class="d-flex flex-column justify-center align-center  name"
    >
      <h5>{{ data.first_name }}</h5>
    </section>
    <div class="flex-column ma-4">
      <v-progress-linear
        v-for="lesson in lessons"
        :key="lesson.lesson"
        :value="lesson.progress"
        color="primary"
        height="40"
        :class="['mb-3 lesson-progress', lessonClassNameToKebab(lesson.lesson)]"
        background-opacity="0.7"
      >
        <span>{{ lesson.lesson }} ({{ lesson.progress }}%)</span>
      </v-progress-linear>
    </div>
    <!-- <v-data-table
      class="lessonTable"
      :headers="headers"
      :items="lessons"
      hide-default-footer
    >
      <template v-slot:items="props">
        <td>{{ props.item.lesson }}</td>
        <td class="text-right">{{ props.item.progress }}</td>
      </template>
    </v-data-table> -->
    <v-card-text class="pt-0">
      <v-btn
        block
        color="primary"
        outlined
        @click="showIndiviudalDetails(data.id)"
      >
        edit or view report
      </v-btn>
      <v-btn block color="primary" class="mt-2" outlined @click="switchUser">
        switch account
      </v-btn>
    </v-card-text>
    <manage-individual
      ref="manageIndividual"
      :individual-id.sync="individualId"
    />
  </v-card>
</template>

<script>
import ManageIndividual from '@/modules/individual/views/manage_individual/ManageIndividual'
import UserLesson from '@/modules/lesson/models/UserLesson'
import Lesson from '@/modules/lesson/models/Lesson'
import _ from 'lodash'

export default {
  name: 'ChildCard',
  components: {
    ManageIndividual
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      individualId: null,
      headers: [
        { text: 'Lesson', value: 'lesson', sortable: false },
        { text: 'Progress', value: 'progress', align: 'right' }
      ],
      backgroundColors: [
        '#F44336',
        '#FF4081',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#03A9F4',
        '#00BCD4',
        '#009688',
        '#4CAF50',
        '#8BC34A',
        '#CDDC39',
        '#FFC107',
        '#FF9800',
        '#FF5722',
        '#795548',
        '#9E9E9E',
        '#607D8B'
      ]
    }
  },
  computed: {
    background() {
      return this.randomBackgroundColor(
        this.data.first_name.length,
        this.backgroundColors
      )
    },
    lessons() {
      const lessons = Lesson.all()
      let completionLesson = []
      lessons.forEach(l => {
        if (
          UserLesson.query()
            .where('entity_id', this.data.id)
            .where('lesson_id', l.id)
            .where('is_completed', true)
            .count()
        ) {
          completionLesson.push({
            lesson: l.name,
            progress: 100
          })
        } else if (
          UserLesson.query()
            .where('entity_id', this.data.id)
            .where('lesson_id', l.id)
            .count()
        ) {
          const userLessons = UserLesson.query()
            .where('entity_id', this.data.id)
            .where('lesson_id', l.id)
            .orderBy('updated_at', 'desc')
            .first()
          completionLesson.push({
            lesson: l.name,
            progress:
              (userLessons.user_lesson_slides.length / l.total_slides) * 100
          })
        } else {
          completionLesson.push({
            lesson: l.name,
            progress: 0
          })
        }
      })
      return completionLesson
    }
  },
  async created() {
    await UserLesson.dispatch('getLessonsForChildId', this.data.id)
  },
  methods: {
    randomBackgroundColor(seed, colors) {
      return colors[seed % colors.length]
    },
    switchUser() {
      this.$emit('manageChild', this.data)
    },
    async showIndiviudalDetails(individualId) {
      this.$store.state.loading = true
      this.individualId = individualId
      await this.$nextTick(async () => {
        await this.$refs.manageIndividual.initialise()
        this.$store.state.loading = false
        this.$refs.manageIndividual.drawer = true
      })
    },
    lessonClassNameToKebab(lesson) {
      return _.kebabCase(lesson)
    }
  }
}
</script>

<style lang="scss">
.child-card-component {
  min-height: 445px;

  .lesson-progress {
    text-align: left;

    span {
      color: white;
      text-align: left;
      font-size: 13px;
      display: block;
      width: 100%;
      padding-left: 10px;
    }
  }

  .lessonTable {
    tbody {
      display: block;
      overflow: auto;
      height: 200px;
      width: 100%;
    }
    thead,
    tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed; /* even columns width , fix width of table too*/
    }
  }

  .name {
    height: 200px;

    h5 {
      font-size: 3em;
      text-transform: capitalize;
      color: white;
    }
  }
}
</style>
